import {AfterViewInit, Component, NgZone, OnInit} from '@angular/core';
import {UserService} from "../../../service/user.service";
import { HttpService } from '../../../service/http.service';
import {BuildingsService} from "../../../service/buildings.service";
import {eventEmitterService} from "../../../service/eventEmitter.service";
import {Router} from "@angular/router";
import * as _ from 'lodash';
import {environment} from "../../../../environments/environment";
import * as XLSX from 'xlsx';
import { timer } from 'rxjs';

declare var $:any;

@Component({
  selector: 'app-resident-list',
  templateUrl: './resident-list.component.html',
  styleUrls: ['./resident-list.component.css']
})
export class ResidentListComponent implements OnInit, AfterViewInit {
  // Local storage variables
  id = localStorage.getItem('residents');
  isManager = localStorage.getItem('isManager');
  userType = localStorage.getItem('type');
  userBuildingId = localStorage.getItem('userBuildingId');
  isManagerExists = false;
  // Resident list variables
  residentList = [];
  residentCountFirstLoad = 0;
  filteredResidentList = [];
  allResidentList = [];
  names='';
  buildingArray=[];
  buildingNames=[];
  successMsg = false;
  // building list vars
  myBuildings = [];
  allBuildings = [];
  selectedBuildings = [];
  allSelectedBuildings = [];

  residentCount = 0;
  filteredBuildingLength = 0;

  // Flags for error display
  isUserDeleted = false;
  isUserDisabled = false;
  isFiltered = false;
  loader = false;

  environmentUrl = environment.apiUrl;
  s3apiUrl = environment.s3BucketApi;
  importXlsx = { error : [] , exists : [], errors:[], records : [] , results : [] };

  timer;

  allBuildingRecords = [ { buildingInfo : { buildingName : '',
    adr_address : '',
    formattedAddress: '',
    placeId : '',
    googlePlaceId : '',
    coords : {
      lat : '',
      lng : ''
    }
  } }];
  allResidentsRecords = [[{}]];
  allrecords = [{buildingInfo : {} , residents : [] }];

  constructor(private userService: UserService,
              private _http: HttpService,
              private buildingService: BuildingsService,
              private chatService : eventEmitterService,
              private ngZone:NgZone,
              private router: Router) { }

  ngOnInit() {
    $(window).ready(function(){
      $('.tentant_sub_menu ul li').click(function(){
        $('.tentant_sub_menu ul li').removeClass('active');
        $(this).addClass('active');
      })
    })
    if(this.isManager === 'true' && this.userType !== 'admin'){ // if the logged in user is a manager
      this.buildingService.getAllBuildingsByUserId(this.id).subscribe(
        (buildings) => {
          console.log(buildings.data[0].building);
          if(buildings.success){
            this.myBuildings = buildings.data[0].building;
            console.log('My Buildings: ', this.myBuildings);
            if(this.myBuildings.length <= 1){
              this.allBuildings.push(this.myBuildings[0].id);
            }else{
              for (let building of this.myBuildings){
                this.allBuildings.push(building.id);
              }
            }
            // Get all users from all the buildings for a building manager
            this.userService.getAllUsersByBuildingIds(this.allBuildings).subscribe(
              (buildings) => {
                console.log('Building dat]:P{{P: : ', buildings);
                for (let building of buildings.buildings) {
                  console.log('buildings.resident', building.resident);
                  if (building.resident.length > 0) {
                    var diffCount = building.resident.filter((res, index) => res.id === this.id);
                    console.log('Diff Count', diffCount);
                    this.residentCount += building.resident.length - diffCount.length;
                    console.log('building.resident.length', building.resident.length);
                    console.log('this.residentCount',this.residentCount);
                  }
                }
                this.marshalData(buildings.buildings);
              });
          }
        }
      );
    }else if(this.userType === 'admin'){


      let buildingIds;
      this.buildingService.getAllBuildingsByUser(buildingIds).subscribe(
        (buildings) => {
          if(buildings.success){


            this.myBuildings = buildings.data;
            console.log('My Buildings: ', this.myBuildings);
            if(this.myBuildings.length <= 1){
              this.allBuildings.push(this.myBuildings[0].id);
            }else{
              for (let building of this.myBuildings){
                this.allBuildings.push(building.id);
              }
            }

            this.userService.getAllUsersByBuildingIds(this.allBuildings).subscribe(
              (buildings) => {
                console.log('Building dat]:P{{P: : ', buildings);
                for (let building of buildings.buildings) {
                  console.log('buildings.resident', building.resident);
                  if (building.resident.length > 0) {
                    var diffCount = building.resident.filter((res, index) => res.id === this.id);
                    console.log('Diff Count', diffCount);
                      this.residentCount += building.resident.length - diffCount.length;
                      console.log('building.resident.length', building.resident.length);
                      console.log('this.residentCount',this.residentCount);
                  }
                }
                this.marshalData(buildings.buildings);
              });

          }


        });


    }else {
      // Get all users for the cuilding current user belongs to
      this.userService.getAllUsersByBuildingId(this.userBuildingId).subscribe(
        (buildings) => {
          console.log('Building dat]:P{{P: : ', buildings);
          var buildingId = buildings.buildings.id;
          this.allBuildings.push(buildingId);
          if(buildings.buildings.resident){
            this.residentCount = buildings.buildings.resident.length;
            buildings.buildings.resident.forEach((resident) => {
              if ( resident.id != this.id ) {
                resident.lastName = resident.lastName.substring(0, 1);
              }
           });
          }

          this.marshalData(buildings.buildings);
          this._http.isManagerExist(this.id).subscribe(
            (res)=>{
              this.isManagerExists = false;
            },
            (error)=>{
              this.isManagerExists = true;
            });
        }
      );
    }

    // Runs every 10 seconds to check if the user session has logged out and redirects to home page if logged out
    this.ngZone.runOutsideAngular(() => {
      this.timer = timer(1000, 10000)
        .subscribe(i => this.ngZone.run(() => {
          if(_.isUndefined(this.id) || _.isEmpty(this.id)){
            location.href = '/';
          }
        }));
    });
    this.filteredBuildingLength = this.selectedBuildings.length;
  }

  ngAfterViewInit() {
      var that = this;
      $("#import_residents_modal").on('hidden.bs.modal' , function () {
        that.importXlsx = { error : [] , exists : [], errors:[], records : [] , results : [] };
        //$('#import_residents_modal input[type="file"]').val(null);
        $("#import_residents_modal input#residentsImport").val('');
        $("#import_residents_modal input#liveUserImport").val('');
        that.successMsg = false;
      });
  }

  showAllFormBuildings(buildingListManager){
    $(buildingListManager).find('.dropdown-content').toggleClass('show');
  }

  /**
   * Formats data so that it can be used to display required data
   * @param buildings
   */
  marshalData(buildings){
    this.allResidentList = [];
    this.residentList = [];
    var residentsFilterCount = 0;
    var userId = this.id;

    if(buildings.length > 1){
      for(let building of buildings){
        this.allResidentList.push({
          buildingId: building.id,
          residents: building.resident,
          buildingName: (building.buildingName) ? building.buildingName : '',
          address: building.formattedAddress
        });

        if(building.resident){
          this.allSelectedBuildings.push(building.id);
        }

        var allResidents = building.resident;
       // allResidents = allResidents.filter((v, i, a) => i !== a.findIndex( (list) => ( list.id  == userId )));
       // residentsFilterCount = residentsFilterCount + allResidents.length;

      }
      this.residentList = this.allResidentList;
    }else{
      var residents = (buildings.resident) ? buildings.resident : (buildings[0]) ? buildings[0].resident : null;
      this.allResidentList.push({
        buildingId: (buildings.id) ? (buildings.id) : (buildings[0]) ? (buildings[0].id) : null,
        residents: residents,
        buildingName: (buildings.buildingName) ? buildings.buildingName : (buildings[0]) ? buildings[0].buildingName:null,
        address: (buildings.formattedAddress) ? buildings.formattedAddress : (buildings[0]) ? buildings[0].formattedAddress: null
      });
      if(buildings.resident){
        this.allSelectedBuildings.push(buildings.id);
      }

      if(buildings[0]){
        this.allSelectedBuildings.push(buildings[0].id);
      }

     // residents = residents.filter((v, i, a) => i !== a.findIndex( (list) => ( list.id  == userId )));
      //residentsFilterCount = residentsFilterCount + residents.length;
      this.residentList = this.allResidentList;
    }
    //this.residentCount = residentsFilterCount;
    this.residentCountFirstLoad = this.residentCount;
    this.filteredBuildingLength = this.selectedBuildings.length;
  }

  /**
   * Open chat wondow when clicked on a resident
   * @param user
   */
  openChat(user){
    this.chatService.open(user);
  }

  /**
   * Handles Resident Page Alphabet filter
   * Called when clicked on an alphabet
   * @param character
   */
  filterResidentList(character, ele = null) {
    if(ele){
      $('.tentant_sub_menu ul li').removeClass('active');
      $('.tentant_sub_menu ul li:nth-child(2)').addClass('active');
    }
    this.isFiltered = true;
    //console.log('All Resident List : ', this.allResidentList, 'Character:', character);
    let i = 0;
    var buildingList = [];
    var selectedBuildingIds = (this.selectedBuildings.length > 0) ? this.selectedBuildings : this.allBuildings;

    if (character != 'all' && character != 'staff') {
      for (let building of this.allResidentList) {
        buildingList.push(building.residents);
      }
      //console.log('Building List: ', buildingList);
      this.userService.getAllUsersFilteredByLetter(character, selectedBuildingIds).subscribe(
        (data) => {
          if (data.buildings) {
            this.marshalData(data.buildings);
            this.isFiltered = false;
          }
        }
      );

    }else if(character == 'staff'){
      this.userService.getAllTeamMembersByBuildingIds(selectedBuildingIds).subscribe(
        (data) => {
          if (data.buildings) {
            this.marshalData(data.buildings);
          }
        }
      );
    }else {
      this.userService.getAllUsersByBuildingIds(selectedBuildingIds).subscribe(
        (buildings) => {
          this.marshalData(buildings.buildings);
        }
      );
    }

  }

  userOptionToggle(buildingListManager){
    $(buildingListManager).find('.drop_down_tenant').toggleClass('show');
  }

  refreshData(){
    if(this.isManager === 'true'){
      this.buildingService.getAllBuildingsByUserId(this.id).subscribe(
        (buildings) => {
          console.log(buildings.data[0].building);
          if(buildings.success){
            this.myBuildings = buildings.data[0].building;
            console.log('My Buildings: ', this.myBuildings);
            if(this.myBuildings.length <= 1){
              this.allBuildings.push(this.myBuildings[0].id);
            }else{
              for (let building of this.myBuildings){
                this.allBuildings.push(building.id);
              }
            }
            this.userService.getAllUsersByBuildingIds(this.allBuildings).subscribe(
              (buildings) => {
                console.log('Building dat]:P{{P: : ', buildings);
                this.marshalData(buildings.buildings);
              }
            );
          }
        }
      );
    }else {
      this.userService.getAllUsersByBuildingId(this.userBuildingId).subscribe(
        (buildings) => {
          console.log('Building dat]:P{{P: : ', buildings);
          this.marshalData(buildings.buildings);
        }
      );
    }
  }

  /**
   * Filters user by selected building
   * @param buildingId
   * @param event
   */
  filterUsersByBuilding(buildingId, event){
    $('.tentant_sub_menu ul li').removeClass('active');
    $('.tentant_sub_menu ul li:first-child').addClass('active');
    this.isFiltered = true;
    if(event.target.checked){
      this.selectedBuildings.push(buildingId);
    }else{
      _.forEach(this.selectedBuildings, (val, key) => {
        if(val === buildingId){
          this.selectedBuildings.splice(this.selectedBuildings.indexOf(val),1);
        }
      });
    }

    var selectedBuildingIds = (this.selectedBuildings.length > 0) ? this.selectedBuildings : this.userBuildingId;
    this.userService.getAllUsersByBuildingIds(selectedBuildingIds).subscribe(
      (data) => {
        console.log('Filtered by building', data);
        if(data.buildings){
          this.marshalData(data.buildings);
          this.isFiltered = false;
        }
      }
    );
    this.filteredBuildingLength = this.selectedBuildings.length;
    var tempLength = 0;
    console.log('this.residentCount', this.residentCount);

  }

  /**
   * Removes / Disables a user based on the userId passed
   * @param userId
   * @param event
   */
  removeUser(userId, event){
    console.log('Event Clicked : ', $('#'+ event.target.id).closest('div.group_list'));

    this.userService.removeUserById(userId).subscribe(
      (user) => {
        console.log('Updated User : ', user);
        this.isUserDeleted = true;
        $('#'+ event.target.id).closest('div.group_list').hide(500);
        this.chatService.removedUser(userId);

        setTimeout(
          () => {
            this.isUserDeleted = false;
            this.buildingService.getAllBuildingsByUserId(this.id).subscribe(
              (buildings) => {
                console.log(buildings.data[0].building);
                if(buildings.success){
                  this.myBuildings = buildings.data[0].building;
                  console.log('My Buildings: ', this.myBuildings);
                  if(this.myBuildings.length <= 1){
                    this.allBuildings.push(this.myBuildings[0].id);
                  }else{
                    for (let building of this.myBuildings){
                      this.allBuildings.push(building.id);
                    }
                  }
                  this.userService.getAllUsersByBuildingIds(this.allBuildings).subscribe(
                    (buildings) => {
                      console.log('Building dat]:P{{P: : ', buildings);
                      this.marshalData(buildings.buildings);
                    }
                  );
                }
              }
            );
          }, 3000
        );
      }
    );
  }

  /**
   * Report a user based on the userId passed
   * @param userId
   */
  reportUser(userId) {
    this.userService.flagUserById(userId, this.id).subscribe(
      (data) => {
        if(data){
          console.log(data);
          this.refreshData();
          this.isUserDisabled = true;
          setTimeout(
            () => {
              this.isUserDisabled = false;
            }, 5000
          );
          this.userService.getAllUsersByBuildingIds(this.allBuildings).subscribe(
            (buildings) => {
              console.log('Building data : ', buildings);
              this.marshalData(buildings.buildings);
            }
          );
        }
      }
    );
  }

  /**
   * Adds selected building name to a string that is displayed on the dropdown when a building is selected from it
   * @param event
   * @param building
   */
  buildings(event,building) {
    this.names = '';
    if (event == true) {
      this.buildingArray.push(building.id);
      this.buildingNames.push((building.buildingName) ? building.buildingName : building.formattedAddress.split(',')[0]);
      //this.events.get('eventGroups').patchValue(this.buildingArray);
    } else if (event == false) {
      const index = this.buildingArray.indexOf(building.id);
      if (index !== -1) {
        this.buildingArray.splice(index, 1);
        this.buildingNames.splice(index, 1)
      }
    }
    this.names= this.buildingNames.toString();
  }

  importResidents(){
    this.successMsg = false;
    $("#import_residents_modal").modal('show');
    this.importXlsx = { error : [] , exists : [], errors:[], records : [] , results : [] };
  }

  browseXlsx(fileEleRef){
      $('#residentsImport').val('');
      $(fileEleRef).trigger('click');
      $("#import_residents_modal").modal('show');
      this.importXlsx = { error : [] , exists : [], errors:[], records : [] , results : [] };
  }

  buildResidentsList(fileEleRef){

    $("#import_residents_modal").modal('hide');

    var filesList =  fileEleRef.target.files;
    var rABS = true;
    var sheet_to_json;

    var file = filesList[0];
    var fileName = file.name;
    var extension = file.name.substring(
      file.name.lastIndexOf('.') + 1).toLowerCase();

    $('#residentsImport').val(fileName);

    if(filesList.length > 0) {

      if(extension == "xls" || extension == "xlsx"){

        if(file.size > 1024 * 1024 * 5){
          this.importXlsx = { error : [] , exists : [], errors:[], records : [] , results : [] };
          this.importXlsx.error.push('Allowed file size 5 MB.');
          $("#import_residents_modal").modal('show');
          file = null;
        }else{

          //var form = new FormData();
          //form.append('importCSV' , file);
          //Calls server action to import
          //this.userService.importResidentsList(form).subscribe((res) => {});
          var reader = new FileReader();
          reader.onload = (e: any) => {
            var data = e.target.result;
            if(!rABS) data = new Uint8Array(data);
            var wb = XLSX.read(data, {type: rABS ? 'binary' : 'array'});
            //console.log("Workbook =================", wb);
            /* DO SOMETHING WITH workbook HERE */

            /* grab first sheet */
            const wsname: string = wb.SheetNames[0];
            const ws: XLSX.WorkSheet = wb.Sheets[wsname];

            /* save data */
            sheet_to_json = XLSX.utils.sheet_to_json(ws, {header: 1});
            //console.log("Records =====", sheet_to_json);
            var residentsList = sheet_to_json;

            var totalRecords = sheet_to_json.length;

            var firstName = $.trim(residentsList[0][0]);
            var lastName  = $.trim(residentsList[0][1]);
            var email     = $.trim(residentsList[0][2]);
            var unitNumber = $.trim(residentsList[0][3]);

            if(firstName != "First Name" || lastName != "Last Name" || email != "Email Address" || unitNumber != "Unit Number"){
                this.importXlsx.error.push("Columns Name should be 'First Name', 'Last Name', 'Email Address', 'Unit Number'. ");
            }else{
               var emailRegx = /^\w+([\+\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

               for(var row=1; row<=totalRecords-1; row++) {
                 var excelRow = row +1;
                 var error = false;
                 var fname = $.trim(residentsList[row][0]);
                 var lname = $.trim(residentsList[row][1]);
                 var emailAddress = $.trim(residentsList[row][2]);
                 var unitNumber = $.trim(residentsList[row][3]);

                 if (fname != '' || lname != '' || emailAddress != '' || unitNumber != '') {

                     //Check empty record
                     if (fname == '' || lname == '' || emailAddress == '' || unitNumber == '') {
                       error = true;
                       this.importXlsx.error.push("Row = " + excelRow + " : Some column(s) has empty value.");
                     }

                     //Check first name
                     if (!(fname.length >= 3 && fname.length <= 50)) {
                       error = true;
                       this.importXlsx.error.push("Row = " + excelRow + " : First Name field is accept from 3 - 50 characters value. --> " + fname);
                     }

                     //Check last name
                     if (!(lname.length >= 3 && lname.length <= 50)) {
                       error = true;
                       this.importXlsx.error.push("Row = " + excelRow + " : Last Name field is accept from 3 - 50 characters value. --> " + lname);
                     }

                     //Check email address
                     if (emailAddress && !emailRegx.test(emailAddress)) {
                       error = true;
                       this.importXlsx.error.push("Row = " + excelRow + " : Invalid email address format. --> " + emailAddress);
                     }

                     //Check unit number
                     if (unitNumber.length <= 5) {
                       if (unitNumber && !$.isNumeric(unitNumber)) {
                         error = true;
                         this.importXlsx.error.push("Row = " + excelRow + " : Invalid unit number format. --> " + unitNumber);
                       } else if (unitNumber == 0) {
                         error = true;
                         this.importXlsx.error.push("Row = " + excelRow + " : Unit number field is accept 1 - 5 digits. --> " + unitNumber);
                       }

                     } else {
                       error = true;
                       this.importXlsx.error.push("Row = " + excelRow + " : Unit number field is accept 1 - 5 digits. --> " + unitNumber);
                     }

                     if (!error || this.importXlsx.error.length == 0) {
                       var records = {
                         firstName: fname,
                         lastName: lname,
                         emailAddress: emailAddress,
                         unitNumber: unitNumber
                       }
                       this.importXlsx.records.push(records);
                     }
                 }

               }

             }

            $("#import_residents_modal").modal('show');
          };
          if(rABS) reader.readAsBinaryString(file); else reader.readAsArrayBuffer(file);
        }

      }else{

        this.importXlsx = { error : [] , exists : [], errors:[], records : [] , results : [] };
        this.importXlsx.error.push('Allowed file type - xlsx');
        $("#import_residents_modal").modal('show');
        file = null;
      }
    }
  }

  importResidentsList(fileEleRef){
      this.loader = true;
      $('button.import').attr('disabled','disabled');
      if(this.importXlsx.error.length == 0){
        if(this.importXlsx.records.length > 0){
          var userBuildings = [];

          if(this.selectedBuildings.length == 0 && this.allBuildings.length == 1){
            userBuildings = this.allBuildings;
          }else if(this.selectedBuildings.length > 0){
            userBuildings = this.selectedBuildings;
          }

          var residentsListRecords = { records : this.importXlsx , buildings : userBuildings };
          this.userService.importResidentsList(residentsListRecords).subscribe((response) => {
            if(response.records.results.length > 0){
              this.successMsg = true;
            }

            this.importXlsx = response.records;
            this.importXlsx.error = [];
            this.loader = false;
            $('button.import').removeAttr('disabled');
          });
        }else{
          this.loader = false;
          $('button.import').removeAttr('disabled');
          this.importXlsx.records = [];
        }
      }else{
        this.loader = false;
        $('button.import').removeAttr('disabled');
        this.importXlsx.records = [];
      }

      $(fileEleRef).val('');
      $('#residentsImport').val('');
  }

  browseLiveXlsx(fileEleRef){
    $('#liveUserImport').val('');
    $(fileEleRef).trigger('click');
    $("#import_residents_modal").modal('show');
    this.importXlsx = { error : [] , exists : [], errors:[], records : [] , results : [] };
  }

  importLiveMycoopResidentsList(fileEleRef){

    //$("#import_residents_modal").modal('hide');

    var filesList =  fileEleRef.target.files;
    var rABS = true;
    var sheet_to_json;
    var file = filesList[0];
    var fileName = file.name;
    var extension = file.name.substring(
      file.name.lastIndexOf('.') + 1).toLowerCase();

    $('#liveUserImport').val(fileName);

    var sleepFunction = ( ms ) => {
      const end = +(new Date()) + ms;
      while( +(new Date()) < end ){ }
    }

    if(filesList.length > 0) {

      if(extension == "xls" || extension == "xlsx"){

        if(file.size > 1024 * 1024 * 20){
          alert('Maximum file size should be 20mb')
          file = null;
        }else{

          var findRecords = [];
          var errorRecords = [];

          var reader = new FileReader();
          reader.onload = (e: any) => {
            var data = e.target.result;
            if(!rABS) data = new Uint8Array(data);
            var wb = XLSX.read(data, {type: rABS ? 'binary' : 'array'});
            //console.log("Workbook =================", wb);
            /* DO SOMETHING WITH workbook HERE */
            wb.SheetNames.forEach((sheet) => {
              /* grab first sheet */
              const wsname: string = sheet;
              const ws: XLSX.WorkSheet = wb.Sheets[wsname];

              /* save data */
              sheet_to_json = XLSX.utils.sheet_to_json(ws, {header: 1});

              var residentsList = sheet_to_json;

              var totalRecords = sheet_to_json.length;

              for(var row=1; row<=totalRecords-1; row++){

                  var guid = $.trim(residentsList[row][0]);
                  var firstName  = $.trim(residentsList[row][1]);
                  var lastName  = $.trim(residentsList[row][2]);
                  var email     = $.trim(residentsList[row][3]);
                  var telephone = $.trim(residentsList[row][4]);
                  var building_guid = $.trim(residentsList[row][5]);
                  var address_id  = $.trim(residentsList[row][6]);
                  var building_name     = $.trim(residentsList[row][7]);
                  var building_address = $.trim(residentsList[row][8]);
                  var formatted_address = $.trim(residentsList[row][9]);
                  var latitude  = $.trim(residentsList[row][10]);
                  var longitude     = $.trim(residentsList[row][11]);

                  var userData = { firstName : firstName, lastName : lastName, email : email, telephone: telephone};
                  //Call place id
                  this._http.getlatlng(formatted_address).subscribe((res)=> {
                      //console.log("===============================Getting Place ID ============",res);
                      if( res.results.length > 0 && res.status == "OK" ){
                        if(address_id && building_guid) {
                          this.allBuildingRecords[building_guid] = {
                            buildingInfo: {
                              buildingName: building_name,
                              adr_address: formatted_address,
                              formattedAddress: formatted_address,
                              placeId: address_id,
                              googlePlaceId : res.results[0].place_id,
                              coords: {
                                lat: latitude,
                                lng: longitude
                              }
                            },
                          };

                          if (findRecords.indexOf(building_guid) > -1) {
                            this.allResidentsRecords[building_guid].push(userData);
                          } else if (findRecords.indexOf(building_guid) < 0) {
                            this.allResidentsRecords[building_guid] = [userData];
                            findRecords.push(building_guid);
                          }

                          this.allResidentsRecords[building_guid] = this.allResidentsRecords[building_guid].filter(function () {
                            return true;
                          });

                          this.allrecords[building_guid] = {
                            buildingInfo: this.allBuildingRecords[building_guid].buildingInfo,
                            residents: this.allResidentsRecords[building_guid]
                          };

                          this.allrecords = this.allrecords.filter(function () {
                            return true;
                          });

                        }else{
                          errorRecords.push({guid: guid, firstName : firstName, lastName : lastName, address_id : address_id, building_guid : building_guid });
                        }
                      }
                  });
                }

                $("#import_residents_modal").modal('show');
            });
            setTimeout(() => {
              if(this.allrecords){
                console.log("======================All Records With Place ID =====", this.allrecords);
                this.userService.importLiveMycoopResidentsList({ liveUsers : this.allrecords}).subscribe((response) => {
                     console.log(response);
                });
              }
            },5000);
          };
          if(rABS) reader.readAsBinaryString(file); else reader.readAsArrayBuffer(file);
        }

      }else{

        this.importXlsx = { error : [] , exists : [], errors:[], records : [] , results : [] };
        this.importXlsx.error.push('Allowed file type - xlsx');
        $("#import_residents_modal").modal('show');
        file = null;
      }
    }
  }

}
